/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import axios from 'axios';
import Loader from "react-js-loader";
import { toAbsoluteUrl } from '../../../../../../_metronic_front/helpers';
import { AddBank } from './AddBank';
import { showToastMessageSuccess, showToastMessageError } from '../../../../../modules/Toast-Message/TosatMessage';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
    const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    return JSON.parse(data);
};

const Banking = () => {

    const APP_URL = process.env.REACT_APP_URL;

    const [showAddBankModal, setShowAddBankModal] = useState(false);
    const [showEditBankModal, setShowEditBankModal] = useState(false);
    const [editBankData,setEditBankData] = useState([
        {
            item_id:'',
            account_name : '',
            account_type:'',
            bank_name : '',
            account_number : '',
            routing_number : '',
            primary_status : ''
        }
    ]);

    const [banksData, setBanksData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh,setRefresh] = useState(false);



    const apiToken = getLocalData().api_token;

    const API_URL = process.env.REACT_APP_API_URL;
    const BANKS = `${API_URL}/user/banks`;
    const BANK_DELETE = `${API_URL}/user/bank/delete`;

    const getUserBanks = async () => {
        setLoading(true);
        const config = {
            headers: { Authorization: `Bearer ${apiToken}` }
        };
        await axios.get(BANKS, config)
            .then((response) => {
                setBanksData(response.data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    const DeleteUserBank = async (myid) => {
        setLoading(true);
        const config = {
            headers: { Authorization: `Bearer ${apiToken}` }
        };
        await axios.post(BANK_DELETE, {bank_id:myid} , config)
            .then((response) => {
                showToastMessageSuccess(response.data.message);
                setRefresh(true)
            })
            .catch((error) => {
                console.error(error);
                setRefresh(true)
            });
    };

          

    useEffect(() => {
            getUserBanks();
            setRefresh(false)
    }, [refresh]);


    const setEditItems = (item)=>{
        setEditBankData({
                item_id:item.item_id,
                account_name: item.account_name,
                account_type:item.account_type,
                bank_name:item.bank_name,
                account_number:item.account_number,
                routing_number:item.routing_number,
                primary_status:item.primary_status,
        })
        setShowEditBankModal(true)
    }

    const SetBankDelete = (id) =>{
        DeleteUserBank(id);
    }

    return (
        <div>
        <AddBank
        show={showAddBankModal}
        handleClose={() => {
          setShowAddBankModal(false);
        }}
        SuccessRefresh={()=>{
            setRefresh(true);
        }}
        EditBankData=''
      />
        <AddBank
        show={showEditBankModal}
        handleClose={() => {
          setShowEditBankModal(false);
        }}
        SuccessRefresh={()=>{
            setRefresh(true);
        }}
        EditBankData={editBankData.item_id != '' ? editBankData : ''}
      />
        
        <div className='cursor-pointer'>
            <div className='m-5 mb-0'>
                <div className="d-flex flex-column flex-column-fluid">
                    <div id="kt_app_content" className="app-content flex-column-fluid">
                        <div className="card shadow mb-5">
                            <div className="card-body py-10">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h2 className="mb-9">My Bank Accounts</h2>
                                <button  onClick={()=> setShowAddBankModal(true)} className='btn btn-primary btn-sm me-2'>Add Bank</button>
                                </div>
                                <div className="row mb-10">
                                    {/* USER CARDS */}
                                {banksData.map((item,index)=>(

                                    
                                <div className="col-lg-6 col-md-12 mb-3" key={index}>
                                    <div className="card shadow px-1">
                                        <div className="card-body ps-2">
                                            <div className="row">
                                                <div className="col-lg-2 col-sm-1 d-none d-md-block">
                                                    <div className="img-wrap ms-2 d-flex align-items-center justify-content-center bg-gray-200" style={{borderRadius:15,height:75,width:75}}>
                                                        <i className="bi bi-bank" style={{fontSize:45}}></i>
                                                        {/* <span><i className="bi bi-bank me-2"></i></span> */}
                                                    </div>
                                                </div>
                                                <div className='col-lg-10 col-sm-12'>
                                                    <div className="detail-wrap">
                                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                                            <h3>{item.bank_name}</h3>
                                                            {item.primary_status == 1 && (
                                                                <span className='badge badge-success ms-2'>primary</span>
                                                            )}
                                                        </div>
                                                        <div className="border-bottom my-2"></div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <span className='text-gray-500 fs-5 fw-bold'>{item.account_name} - {item.account_number}</span>
                                                             <div className="d-flex">
                                                                <button onClick={()=> setEditItems(item)} className='btn btn-light btn-sm me-2'>Edit</button>
                                                                <button onClick={()=> SetBankDelete(item.item_id)} className='btn btn-light btn-sm'>Delete</button>
                                                             </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                ))
                            }
                                
                                    
                                </div>

                            </div>
                        </div>
                        {/* List of Transctions , view backup */}
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}

export { Banking };
